/* 
  Optimized Custom JS - Vanilla JavaScript (No jQuery)
  Performance: High
*/

function openDetailsTab() {
    // querySelector is the native equivalent of $()
    const tab = document.querySelector('.popup-details-tab');
    const overlay = document.querySelector('.popup-details-overlay');

    // Safe check: Only add class if elements exist to prevent errors
    if (tab) tab.classList.add('active');
    if (overlay) overlay.classList.add('active');
}

function closeDetailsTab() {
    const tab = document.querySelector('.popup-details-tab');
    const overlay = document.querySelector('.popup-details-overlay');

    if (tab) tab.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
}

async function copyCurrentUrl() {
    // This function was already native JS, just added safety checks
    try {
        const url = window.location.href;
        await navigator.clipboard.writeText(url);
        console.log('Text copied to clipboard successfully!');
        
        const highlightElement = document.getElementById('highlightTextCopy');
        if (highlightElement) {
            highlightElement.innerText = 'Link Copied ✓';
            setTimeout(() => {
                highlightElement.innerText = 'Copy link';
            }, 3000);
        }
    } catch (err) {
        console.error('Failed to copy text: ', err);
    }
}

const toggleSeeMoreCare = () => {
    const careSection = document.getElementById('care-see-more');
    const btn = document.getElementById('seeMoreBtn');

    if (careSection) {
        // Native equivalent of jQuery .toggle()
        // Checks if it's currently hidden via CSS or inline style
        const isHidden = window.getComputedStyle(careSection).display === 'none';
        careSection.style.display = isHidden ? 'block' : 'none';
    }

    if (btn) {
        // Native equivalent of jQuery .text()
        const currentText = btn.textContent || btn.innerText;
        btn.textContent = currentText.trim() === 'See More' ? 'See Less' : 'See More';
    }
}